"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* global $, Swiper, Sticky */

document.addEventListener("DOMContentLoaded", function () {
  var getElementHeight = function getElementHeight(selector) {
    return +$(selector).outerHeight(true);
  };
  var getElementOffsetTop = function getElementOffsetTop(selector) {
    return +$(selector).offset().top;
  };
  function KlaviyoSubscribe(listID, email, source, $form) {
    $.ajax({
      type: "POST",
      url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      data: {
        g: listID,
        email: email,
        // phone_number: phone,
        // sms_consent: true,
        $fields: "$source",
        $source: source
      },
      contentType: "application/x-www-form-urlencoded",
      error: function error(err) {
        // console.log("Could not connect to Klaviyo.");
        // console.log(err);
      },
      success: function success(data) {
        // console.log("success");
        // console.log(data);

        $form.after("<p>Thank You For Subscribing!</p>");
        $form.hide();
      }
    });
  }
  function KlaviyoTrackEvent(publicApiKey, email, eventName) {
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/api/track",
      data: $.param({
        data: JSON.stringify({
          token: publicApiKey,
          event: eventName,
          customer_properties: {
            $email: email
          },
          properties: {
            email: email
          }
        })
      }),
      contentType: "application/x-www-form-urlencoded",
      dataType: "json",
      error: function error(err) {
        console.error("Could not send event to Klaviyo:", err);
      },
      success: function success(response) {
        console.log("Event sent successfully:", response);
      }
    });
  }
  function toggleSwiperClass($element) {
    $element.toggleClass("swiper");
    $element.find(".sw-wrapper").toggleClass("swiper-wrapper");
    $element.find(".sw-slide").toggleClass("swiper-slide");
    $element.find(".sw-scrollbar").toggleClass("swiper-scrollbar");
    $element.find(".sw-prev").toggleClass("swiper-button-prev");
    $element.find(".sw-next").toggleClass("swiper-button-next");
    $element.find(".sw-pagination").toggleClass("swiper-pagination");
  }
  function responsiveSwiper($element, options, breakpoint) {
    var init = false;
    var swiper;
    function swiperCard() {
      if (window.innerWidth < breakpoint) {
        if (!init) {
          init = true;
          toggleSwiperClass($element);
          swiper = new Swiper($element[0], options);
        }
      } else if (init) {
        swiper.destroy();
        init = false;
        toggleSwiperClass($element);
      }
    }
    swiperCard();
    window.addEventListener("resize", swiperCard);
  }
  var swiperSlide = function swiperSlide(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var $sliders = $(selector);
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      new Swiper($(this)[0], options);
    });
  };
  var equalizeHeight = function equalizeHeight(container) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var $container = $(container);
    $container.equalize(options);
    $(window).resize(function () {
      return $container.equalize(options);
    });
  };
  (function () {
    // Init Sliders
    // Featured Collections section
    swiperSlide(".feat-col .swiper-slider-feat-collections", {
      slidesPerView: 1.5,
      centeredSlides: false,
      slidesPerGroupSkip: 2,
      grabCursor: false,
      keyboard: {
        enabled: true
      },
      loop: false,
      spaceBetween: 20,
      breakpoints: {
        720: {
          slidesPerView: 2.5
        },
        1320: {
          slidesPerView: 3,
          slidesPerGroup: 1
        }
      },
      navigation: {
        nextEl: ".swiper-arrow"
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        // dragSize: 50,
        hide: false,
        draggable: true,
        snapOnRelease: true
      }
    });

    // Collection Breadcrumbs section
    // swiperSlide(".collection-breadcrumbs .swiper-breadcrumbs", {
    // 	direction: "horizontal",
    // 	slidesPerView: "auto",
    // 	freeMode: true,
    // 	mousewheel: true,
    // });

    // Breadcrumbs section
    swiperSlide(".breadcrumbs-section .swiper-breadcrumbs", {
      direction: "horizontal",
      slidesPerView: "auto",
      freeMode: true,
      mousewheel: true
    });

    // Collections Product block
    swiperSlide(".feat-col-slider .feat-col-slider__loop", {
      // createElements: true,
      slidesPerView: 1.5,
      centeredSlides: false,
      loop: true,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        720: {
          slidesPerView: 2.3,
          spaceBetween: 30
        },
        1320: {
          slidesPerView: 3,
          spaceBetween: 35
        }
      }
    });

    // Collections List section
    swiperSlide(".col-list .col-list__loop.col-swiper", {
      slidesPerView: 1.25,
      spaceBetween: 20,
      centeredSlides: false,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        540: {
          slidesPerView: 1.5
        },
        720: {
          slidesPerView: 2.25,
          spaceBetween: 20
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1140: {
          slidesPerView: 4,
          spaceBetween: 40
        },
        1320: {
          slidesPerView: 4,
          spaceBetween: 60
        }
      }
    });

    // Mobile menu swiper
    swiperSlide(".gheader__mobile-menu .col-list__loop.menu-swiper", {
      slidesPerView: 2.25,
      spaceBetween: 20,
      height: 200,
      centeredSlides: false,
      loop: false
    });

    // Products List section
    swiperSlide(".col-list .col-list__loop.prod-swiper", {
      slidesPerView: 1.25,
      spaceBetween: 20,
      centeredSlides: false,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        540: {
          slidesPerView: 1.5
        },
        720: {
          slidesPerView: 2.25,
          spaceBetween: 20
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1140: {
          slidesPerView: 4,
          spaceBetween: 40
        },
        1320: {
          slidesPerView: 4,
          spaceBetween: 60
        }
      }
    });

    // Subscribe page
    swiperSlide(".product-rows .product-rows__loop", {
      slidesPerView: 1.25,
      spaceBetween: 14,
      centeredSlides: false,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        540: {
          slidesPerView: 1.5,
          spaceBetween: 15
        },
        720: {
          slidesPerView: 2.25,
          spaceBetween: 20
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1320: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      }
    });

    // Featured Collections Simple section
    swiperSlide(".collection-list .swiper-slider-collection-list", {
      slidesPerView: 1.25,
      centeredSlides: false,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        720: {
          slidesPerView: 2.25,
          spaceBetween: 25
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1320: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    });

    // Blog article page
    swiperSlide(".article-ymal .ymal__loop", {
      slidesPerView: 1.25,
      centeredSlides: false,
      loop: false,
      direction: "horizontal",
      mousewheel: true,
      spaceBetween: 20,
      breakpoints: {
        540: {
          slidesPerView: 2.25,
          spaceBetween: 20
        },
        720: {
          slidesPerView: 2,
          spaceBetween: 35
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });

    // Blog article page
    swiperSlide(".related-posts .related-posts__loop", {
      // createElements: true,
      slidesPerView: 1.25,
      centeredSlides: false,
      loop: false,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        540: {
          slidesPerView: 2.25,
          spaceBetween: 20
        },
        720: {
          slidesPerView: 2,
          spaceBetween: 35
        },
        960: {
          slidesPerView: 3,
          spaceBetween: 35
        },
        1140: {
          slidesPerView: 4,
          spaceBetween: 35
        }
      }
    });

    // Home page
    swiperSlide(".feat-testi .feat-testi__loop", {
      slidesPerView: 1.25,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        960: {
          slidesPerView: 2,
          spaceBetween: 50
        }
      }
    });
    swiperSlide(".reviews-carousel-section .reviews-carousel-section__loop", {
      direction: "vertical",
      effect: "slide",
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: true,
      loop: true,
      autoplay: {
        delay: 5000,
        reverseDirection: false,
        disableOnInteraction: false
      },
      breakpoints: {
        960: {
          slidesPerView: 1,
          spaceBetween: 10,
          autoHeight: true
        }
      }
    });
    swiperSlide(".col-testi .slick-slider-author", {
      slidesPerView: 1.25,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        960: {
          slidesPerView: 2,
          spaceBetween: 50
        }
      }
    });

    // Global Testimonial Swiper
    // swiperSlide(".global-testimonial-swiper .global-testimonial-swiper__loop", {
    // 	slidesPerView: 1,
    // 	spaceBetween: 40,
    // 	loop: false,
    // 	breakpoints: {
    // 		960: { slidesPerView: 4, spaceBetween: 20 },
    // 	},
    // });

    // Editorial Testimonial Quote section
    swiperSlide(".editorial-testimonial-quote .editorial-testimonial-quote__loop", {
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 120,
      centeredSlides: false,
      pagination: {
        el: ".editorial-testimonial-quote__pagination",
        clickable: true
      },
      loop: true,
      breakpoints: {
        960: {
          slidesPerView: 2,
          spaceBetween: 120
        }
      }
    });
  })();
  (function () {
    // Lazy Loading
    var instance = new LazyLoad();
    function lazyBGImages() {
      var $bgImages = document.querySelectorAll("[data-bg]:not(.lazy)");
      if ($bgImages.length) {
        $bgImages.each(function () {
          $(this).addClass("lazy");
        });
      }
      instance.update();
    }
    function update() {
      lazyBGImages();
    }
    lazyBGImages();
    return {
      update: update
    };
  })();
  (function () {
    // Function top open / close lightboxes
    // Lightbox reset - This lightbox is empty and present on all pages
    var $lightbox = $(".pdm-lightbox--reset");

    // It's content can be filled from various sources after close, the content is wiped
    var $lightbox_content = $(".pdm-lightbox--reset .pdm-lightbox__content");
    $("body").on("click", "[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger", function (e) {
      e.preventDefault();
      var iframe = $(this).data("lightbox-iframe");
      if (iframe) {
        var replacement = "";
        var youtubePattern = /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w-]{11})(?:\S+)?$/g;
        var vimeoPattern = /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?(?:vimeo\.com\/(?:channels\/\w+\/)?|(?:(?:www|player)\.)?vimeo\.com\/(?:showcase\/\w+\/)?video\/)(\d+)(?:\S+)?$/g;
        if (youtubePattern.test(iframe)) {
          // classes += " youtube-vid";

          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(youtubePattern, replacement);
        }
        if (vimeoPattern.test(iframe)) {
          // classes += " vimeo-vid";

          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://player.vimeo.com/video/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(vimeoPattern, replacement);
        }
        $lightbox_content.html('<div class="video-embed">' + iframe + "</div>");
      } else {
        var content = "";
        if ($(this).data("lightbox-content")) {
          content = $(this).data("lightbox-content");
        } else if ($(this).data("lightbox-target")) {
          var target = $(this).data("lightbox-target");
          content = $("#" + target).html();
        } else {
          content = $(this).next(".lightbox-content").html();
        }
        $lightbox_content.html(content);
      }
      var classes = $(this).data("lightbox-classes");
      $lightbox.addClass("active").addClass(classes);
    });
    function closeModal($lightbox) {
      $lightbox.removeClass("active");
      $("body").removeClass("noScroll");

      // Wait before removing classes till lightbox closses
      if ($lightbox.hasClass("pdm-lightbox--reset")) {
        setTimeout(function () {
          $lightbox.find(".pdm-lightbox__content").empty();
          $lightbox.attr("class", "pdm-lightbox pdm-lightbox--reset");
        }, 750);
      }
    }
    function openModal($lightbox) {
      $lightbox.addClass("active");
      $("body").addClass("noScroll");
    }
    function updateModal($lightbox, $content) {
      $lightbox.find(".pdm-lightbox__content").html($content);
    }
    $(".pdm-lightbox").on("click", function (e) {
      if (e.target == this) {
        closeModal($(this));
      }
    });
    $(".pdm-lightbox__close").click(function (e) {
      e.stopPropagation();
      closeModal($(this).closest(".pdm-lightbox"));
    });
    return {
      close: closeModal,
      open: openModal,
      update: updateModal
    };
  })();
  (function () {
    // Smooth Scroll
    $(document).on("click", 'a[href^="#"]', function (event) {
      event.preventDefault();
      var scrollPoss = 0;
      scrollPoss -= $("header").outerHeight() || 0;
      scrollPoss -= $(".breadcrumbs").outerHeight() || 0;
      scrollPoss -= $("#rebuy-quick-view-dropdown-search .rebuy-quick-view-dropdown__container.visible").outerHeight() || 0;
      scrollPoss -= $(".ju_Con").outerHeight() || 0;
      // scrollPoss += 200;

      $("html, body").animate({
        scrollTop: $($.attr(this, "href")).offset().top + scrollPoss
      });
    });
  })();
  var sticky = function (_$sticky$data) {
    // Sticky Element
    var $sticky = $("[data-sticky]");
    var headerHeight = getElementHeight("header.gheader");
    var announcementBarHeight = getElementHeight(".announcement-bar__wrapper");
    var dataMarginTop = (_$sticky$data = $sticky.data("margin-top")) !== null && _$sticky$data !== void 0 ? _$sticky$data : 0;
    $sticky.attr("data-margin-top", headerHeight + announcementBarHeight + dataMarginTop);
    return new Sticky("[data-sticky]", {});
  }();
  (function () {
    // Accordions
    var $accordions = $(".accordion");
    if (!$accordions.length) {
      return;
    }
    var windowWidth = $(window).width();
    var index = 0;
    $accordions.each(function () {
      var _this = this;
      var showActive = function showActive() {
        if ($(_this).hasClass("active")) {
          $(_this).find(".accordion__content").show("fast");
        }
      };
      if ($(this).hasClass("active-desktop")) {
        // open the first accordion and close the others
        if (windowWidth <= 720 && index) {
          $(this).removeClass("active");
        } else {
          showActive();
        }
        index += 1;
      } else {
        showActive();
      }
    });
    $accordions.find(".accordion__trigger").click(function (event) {
      var $this = $(this);
      var $accordion = $this.parent();
      var $content = $accordion.find(".accordion__content");
      var $siblings = $accordion.siblings();
      if ($accordion.hasClass("active")) {
        $accordion.removeClass("active");
        $content.slideUp("fast");
      } else {
        $accordion.addClass("active");
        if ($this.parent().hasClass("accordion-single")) {
          $siblings.removeClass("active").find(".accordion__content").slideUp("fast");
          setTimeout(function () {
            var elementId = $this.parent().attr("id");
            var headerHeight = getElementHeight(".gheader") || 0;
            var breadcrumbsHeight = getElementHeight(".breadcrumbs") || 0;
            var scrollTop = $("#".concat(elementId)).offset().top - (headerHeight + breadcrumbsHeight + 200) - 30;
            $([document.documentElement, document.body]).animate({
              scrollTop: scrollTop
            }, 500);
          }, 200);
        }
        $content.slideDown("fast");
      }

      // Timer 200 because slideUp/slideDown with 'fast' takes 200 milliseconds
      setTimeout(function () {
        return sticky.update();
      }, 200);
    });
  })();
  (function () {
    // Collapse (show/hide)
    var $collapses = $(".collapse");
    if (!$collapses.length) {
      return;
    }
    $collapses.each(function () {
      var $this = $(this);
      if ($this.hasClass("active")) {
        $this.find(".accordion__content").show("fast");
      }
    });
    $collapses.find(".collapse-trigger").click(function (event) {
      var $this = $(this);
      var $collapse = $this.parent();
      var $content = $collapse.find(".collapse-content");
      var dataTextExpand = $collapse.data("text-expand") || "Read More";
      var dataTextCollapse = $collapse.data("text-collapse") || "Read Less";
      if ($collapse.hasClass("active")) {
        $collapse.removeClass("active");
        $content.slideUp("fast");
        $this.text(dataTextExpand);
      } else {
        $collapse.addClass("active");
        $content.slideDown("fast");
        $this.text(dataTextCollapse);
      }

      // Timer 200 because slideUp/slideDown with 'fast' takes 200 milliseconds
      setTimeout(function () {
        return sticky.update();
      }, 200);
    });
  })();
  (function () {
    // More/less text
    $(".more-less-button").click(function () {
      var $this = $(this);
      $this.parent().find(".more-less-text").fadeToggle("fast");

      // Timer 200 because slideUp/slideDown with 'fast' takes 200 milliseconds
      setTimeout(function () {
        return sticky.update();
      }, 200);
      if ($this.text() === "Read More") $this.text("Read Less");else $this.text("Read More");
    });
  })();
  AOS.init();
  (function () {
    // Equalize Height
    equalizeHeight(".equalize-container", {
      reset: true
    });
  })();
  (function () {
    // Subscribing products block
    var $products = $(".product-card");
    $products.each(function () {
      var $this = $(this);
      var $productSubscribe = $this.find(".product-card__subs input[name='checkbox']");
      var $productPlan = $this.find("form.atc-form input[name='selling_plan']");
      var $that = $this;
      $productSubscribe.on("change", function () {
        var $this = $(this);
        var sellingPlan = $this.data("selling-plan");
        var productPrice = $this.data("product-price");
        var sellingPlanDiscount = $this.data("selling-plan-discount");
        var currencySymbol = $this.data("currency-symbol");
        var $priceMain = $that.find(".product-price__main");
        var $priceSubs = $that.find(".product-price__subscription");
        if ($this.is(":checked")) {
          $productPlan.val(sellingPlan);
          if (sellingPlanDiscount) {
            $priceMain.addClass("text-through");
            var newPrice = productPrice - productPrice * (sellingPlanDiscount / 100);
            if (newPrice > 0) {
              $priceSubs.text("".concat(currencySymbol).concat(newPrice.toFixed(2)));
            }
          }
        } else {
          $productPlan.val("");
          $priceMain.removeClass("text-through");
          $priceSubs.text("");
        }
      });
    });
  })();
  (function () {
    // Header section
    var $header = $("header.gheader");

    // Menu burger & Mobile menu
    var $menuBurger = $header.find(".menu-burger");
    var $mobMenu = $header.find(".gheader__mobile-menu");
    var $icons = $header.find(".icons > a");
    $menuBurger.click(function () {
      // Set top to mobile menu
      var headerHeight = getElementHeight("header.gheader");
      var headerOffset = getElementOffsetTop("header.gheader");
      var windowScroll = $(document).scrollTop();
      var offset = headerOffset - windowScroll + headerHeight;
      $mobMenu.css("top", "".concat(offset, "px"));
      $icons.toggleClass("hide");
      $menuBurger.toggleClass("active");
      $mobMenu.toggleClass("active");
      // $('body').toggleClass('no-scroll');
    });
    $mobMenu.find("li.haslinks > a").click(function (event) {
      if (event.target.tagName !== "SPAN") {
        event.preventDefault();
        var $this = $(this);
        $this.toggleClass("active");
        $this.next().slideToggle();
      }
    });

    // Search block
    var $searchIcon = $header.find(".search-icon");
    var $searchCloseIcon = $header.find(".search-close");
    var $searchBlock = $header.find(".gheader__search-bar");
    var showSearchBlock = function showSearchBlock() {
      if ($searchBlock.hasClass("active")) return;
      $searchBlock.removeClass("animate__zoomOut").addClass("animate__zoomIn").addClass("active");
    };
    var hideSearchBlock = function hideSearchBlock() {
      $searchBlock.removeClass("animate__zoomIn").addClass("animate__zoomOut");
      setTimeout(function () {
        $searchBlock.removeClass("active");
      }, 300);
    };

    // $searchIcon.click(showSearchBlock);
    $searchCloseIcon.click(hideSearchBlock);
    $(document).mouseup(function (event) {
      if (!$searchBlock.is(event.target) && $searchBlock.has(event.target).length === 0 && $searchBlock.hasClass("active")) {
        hideSearchBlock();
      }
    });
    var lastScrollTop = 0;
    $(window).scroll(function (event) {
      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        // Down scroll
        hideSearchBlock();
      } else {
        // Up scroll
      }
      lastScrollTop = st;
    });

    // Navigation menu
    var $megaMenu = $header.find(".mega-menus");
    var $megaMenuItems = $header.find(".mega-menus .mega-menu");
    var $navigationItems = $header.find(".navigation .toggle-menu");
    $navigationItems.hover(function () {
      var $this = $(this);
      var menuData = $this.data("menu");
      if (!menuData) return;
      $megaMenu.addClass("active");
      $megaMenuItems.removeClass("active");
      $megaMenuItems.filter('[data-menu="' + menuData + '"]').addClass("active");

      // $('body').addClass('no-scroll');
    }, function () {
      // $megaMenu.removeClass("active");
      // $('body').removeClass('no-scroll');
    });
    $megaMenu.hover(function () {
      return $megaMenu.addClass("active");
    }, function () {
      return $megaMenu.removeClass("active");
    });
    $(window).bind("mousewheel", function (event) {
      if (event.originalEvent.wheelDelta >= 0) {
        // Scroll up
      } else {
        // Scroll down
        $megaMenu.removeClass("active");
      }
    });

    // Mega menu shop
    var $megaMenuShop = $header.find(".mega-menu__shop");
    var $menuShopItems = $megaMenuShop.find(".menu-links li");
    var $menuShopCollections = $megaMenuShop.find(".menu-collections li.menu-collections__item");
    $menuShopItems.hover(function () {
      var $this = $(this);
      var linkData = $this.data("link");
      if (!linkData) return;
      $menuShopItems.removeClass("active");
      $this.addClass("active");
      $menuShopCollections.removeClass("active");
      $menuShopCollections.filter('[data-link="' + linkData + '"]').addClass("active");
    });
  })();
  (function () {
    // Select the footer section
    var $footer = $("footer.gfooter");
    var $footerForm = $footer.find(".newsletter-form");
    $footerForm.submit(function (event) {
      event.preventDefault();
      var $this = $(this);
      var $email = $this.find('[name="email"]');
      var publicApiKey = klaviyoModulesObject.companyId || "";
      var $recaptchaElement = $footer.find(".g-recaptcha");

      // Check if the reCAPTCHA element exists and is completed
      if ($recaptchaElement.length > 0) {
        if (typeof grecaptcha === "undefined" || grecaptcha.getResponse().length === 0) {
          $recaptchaElement.addClass("recaptcha-error");
          //alert('Please complete the reCAPTCHA.'); // Alert if reCAPTCHA is not completed
          return;
        }
      }

      // Validate the email input
      var email = $email.val().trim();
      if (email === "" || !isValidEmail(email)) {
        return;
      }
      KlaviyoSubscribe("HNHAgx", email, "Shopify Footer", $this);
      KlaviyoTrackEvent(publicApiKey, email, "SignUpFooterNewsletter");
    });

    // Helper function to validate email format
    function isValidEmail(email) {
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    }
  })();
  (function () {
    // Testimonials Row section
    var $testimonial = $(".logo-row");
    var $sliderFor = $testimonial.find(".slick-slider-for");
    var $sliderNav = $testimonial.find(".slick-slider-nav");
    var autoCycle = parseInt($sliderFor.data("auto-cycle"));
    var optionsAuto = autoCycle > 0 ? {
      autoplay: true,
      autoplaySpeed: autoCycle * 1000
    } : {};
    var optionsSliderFor = _objectSpread({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: false,
      asNavFor: ".slick-slider-nav",
      adaptiveHeight: false
    }, optionsAuto);
    var optionsSliderNav = {
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".slick-slider-for",
      arrows: false,
      dots: false,
      centerMode: false,
      adaptiveHeight: false,
      focusOnSelect: true,
      responsive: [{
        breakpoint: 720,
        settings: {
          slidesToShow: 2
        }
      }]
    };
    $sliderFor.slick(optionsSliderFor);
    $sliderNav.slick(optionsSliderNav);
  })();

  // (function () {
  // 	// Collection Breadcrumbs section
  // 	const $collectionBreadcrumbs = $(".collection-breadcrumbs");
  // 	const $sectionBreadcrumbs = $(".breadcrumbs-section");

  // 	const initBreadcrumbsSticky = () => {
  // 		$collectionBreadcrumbs.css(
  // 			"top",
  // 			`${getElementHeight("header.gheader")}px`
  // 		);
  // 		$sectionBreadcrumbs.css("top", `${getElementHeight("header.gheader")}px`);
  // 	};

  // 	const initBreadcrumbsScroll = () => {
  // 		let sections = document.querySelectorAll("section");
  // 		let links = document.querySelectorAll(".breadcrumbs-nav a");

  // 		window.onscroll = () => {
  // 			sections.forEach((section) => {
  // 				let top = window.scrollY;
  // 				let offset = section.offsetTop - 100;
  // 				let height = section.offsetHeight;
  // 				let id = section.getAttribute("id");

  // 				if (top >= offset && top < offset + height) {
  // 					links.forEach((link) => {
  // 						link.classList.remove("active");

  // 						const activeLink = document.querySelector(
  // 							`.breadcrumbs-nav a[href*="${id}"]`
  // 						);

  // 						if (activeLink) {
  // 							activeLink.classList.add("active");
  // 						}
  // 					});
  // 				}
  // 			});
  // 		};
  // 	};

  // 	initBreadcrumbsSticky();
  // 	initBreadcrumbsScroll();
  // })();

  (function () {
    // Blog page
    var initFilters = function initFilters() {
      var $blogFilters = $(".blog__filters");
      if (!$blogFilters.length) {
        return;
      }
      $blogFilters.find("input[type=checkbox]").change(function () {
        var $this = $(this);
        if ($this.is(":checked")) {
          window.location = $this.val();
        } else {
          $this.prop("checked", true);
        }
      });
    };
    var initSubscribe = function initSubscribe() {
      var $newsletter = $(".newsletter-headline");
      var $newsletterForm = $newsletter.find(".newsletter-headline__form");
      $newsletterForm.submit(function (event) {
        event.preventDefault();
        var $this = $(this);
        var $email = $this.find('[name="email"]');
        if ($email.val() !== "") {
          KlaviyoSubscribe("HNHAgx", $email.val(), "Shopify Blog", $this);
        }
      });
    };
    initFilters();
    initSubscribe();
  })();

  // Klaviyo extension
  (function () {
    var timer = setInterval(function () {
      var klaviyoForm = $('div[aria-label="POPUP Form"]');
      if (klaviyoForm && klaviyoForm.parent() && klaviyoForm.parent().css("z-index") !== "2147483000") {
        klaviyoForm.parent().css("z-index", "2147483000");
      }
    }, 500);
  })();

  // Rebuy extension
  (function () {
    // Blog page
    // Best sellers widget (rebuy-widget-91529)
    var timer = setInterval(function () {
      var $widget = $("div#rebuy-widget-91529");
      if ($widget.length) {
        clearInterval(timer);
        var $productInfos = $widget.find(".rebuy-product-info");
        $productInfos.each(function () {
          var $this = $(this);
          var $productTitle = $this.find("a.rebuy-product-title").first();
          var $productFlavor = $this.find("div.rebuy-product-flavor p").first();
          var productTitleText = $productTitle.text().toLowerCase();
          var productFlavorText = $productFlavor.text().toLowerCase();
          if (productTitleText.indexOf(productFlavorText) >= 0) {
            $productFlavor.remove();
          }
        });
      }
    }, 500);
  })();

  /**
   * Hides the SC's BMSM section for line items which ARE a subscription
   */
  function disableBMSMonSubscriptionLineItem() {
    return _disableBMSMonSubscriptionLineItem.apply(this, arguments);
  }
  /**
   * Disable function that hides the quantity and always changes the quantity for 1 of the products with subscription
   */
  // document.addEventListener("rebuy:cart.change", (event) => {
  // 	setTimeout(() => {
  // 		disableBMSMonSubscriptionLineItem();
  // 	}, 500);
  // });
  // setTimeout(() => {
  // 	disableBMSMonSubscriptionLineItem();
  // }, 500);
  function _disableBMSMonSubscriptionLineItem() {
    _disableBMSMonSubscriptionLineItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var cartItems, _iterator, _step, _step$value, index, cartItem, thisLineItemBlockElement, thisItemsQuantitySelectorElement, changeEvent, thisItemsBMSMelement;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cartItems = Rebuy.Cart.cart.items;
            _iterator = _createForOfIteratorHelper(cartItems.entries());
            _context.prev = 2;
            _iterator.s();
          case 4:
            if ((_step = _iterator.n()).done) {
              _context.next = 20;
              break;
            }
            _step$value = _slicedToArray(_step.value, 2), index = _step$value[0], cartItem = _step$value[1];
            thisLineItemBlockElement = document.querySelectorAll(".rebuy-cart__flyout-item")[index];
            thisItemsQuantitySelectorElement = document.querySelectorAll(".rebuy-cart__flyout-item-quantity")[index];
            changeEvent = new CustomEvent("rebuy:cart.change");
            if (cartItem !== null && cartItem !== void 0 && cartItem.product) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("continue", 18);
          case 11:
            if (!(cartItem.product.subscription && cartItem.quantity > 1)) {
              _context.next = 15;
              break;
            }
            _context.next = 14;
            return Rebuy.Cart.changeItem({
              id: cartItem.id,
              quantity: 1
            });
          case 14:
            return _context.abrupt("return");
          case 15:
            if (cartItem.product.subscription == undefined) {
              document.dispatchEvent(changeEvent);
            }
            thisItemsBMSMelement = document.querySelectorAll(".rebuy-cart__flyout-item-buy-more-save-more")[index];
            if (cartItem.product.subscription) {
              if (thisItemsBMSMelement) {
                thisItemsBMSMelement.style.display = "none";
              }
              if (thisItemsQuantitySelectorElement) {
                thisItemsQuantitySelectorElement.style.opacity = "0";
                thisItemsQuantitySelectorElement.style.pointerEvents = "none";
              }
              if (thisLineItemBlockElement !== null && thisLineItemBlockElement !== void 0 && thisLineItemBlockElement.classList.contains("property-value-rebuy-buy-more-save-more")) {
                thisLineItemBlockElement.classList.remove("property-value-rebuy-buy-more-save-more");
              }
            } else {
              if (thisItemsBMSMelement) {
                thisItemsBMSMelement.style.display = "block";
              }
              if (thisItemsQuantitySelectorElement) {
                thisItemsQuantitySelectorElement.style.opacity = "1";
                thisItemsQuantitySelectorElement.style.pointerEvents = "all";
              }
            }
          case 18:
            _context.next = 4;
            break;
          case 20:
            _context.next = 25;
            break;
          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](2);
            _iterator.e(_context.t0);
          case 25:
            _context.prev = 25;
            _iterator.f();
            return _context.finish(25);
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 22, 25, 28]]);
    }));
    return _disableBMSMonSubscriptionLineItem.apply(this, arguments);
  }
  var featuredProducts = function () {
    var $slider = $(".featured-products");
    if (!$slider.length) {
      return;
    }
    var options = {
      createElements: true,
      slidesPerView: 3,
      centeredSlides: false,
      loop: true,
      spaceBetween: 16
      // scrollbar: {
      //   el: ".swiper-scrollbar",
      //   draggable: true,
      // },
    };
    responsiveSwiper($slider, options, 1920);
  }();
  var testiTabs = function () {
    var $testiNav = $(".col-testi__nav button");
    if (!$testiNav.length) {
      return;
    }
    var $testiTabs = $(".col-testi__tab");
    $testiNav.click(function () {
      var $this = $(this);
      var type = $this.data("type");
      $testiNav.removeClass("active");
      $this.addClass("active");
      $testiTabs.removeClass("active");
      $testiTabs.filter('[data-type="' + type + '"]').addClass("active");
    });
  }();
  var disableSamplePacks = function () {
    var $sampleATC = $('.atc-btn[data-type="Sample"]');
    if (!$sampleATC.length) {
      return;
    }
    $sampleATC.click(function () {
      $(this).addClass("disabled");
      $(this).text("Added to Cart");
    });
  }();

  // var prodTabs = (function () {
  // 	var $nav = $(".mproduct__tabs__nav button");

  // 	if (!$nav.length) {
  // 		return;
  // 	}

  // 	var $tabs = $(".mproduct__tabs__tab");

  // 	$nav.click(function () {
  // 		var $this = $(this);
  // 		var type = $this.data("tab");

  // 		$nav.removeClass("active");
  // 		$this.addClass("active");

  // 		$tabs.removeClass("active");
  // 		$tabs.filter('[data-tab="' + type + '"]').addClass("active");
  // 	});
  // })();

  // (function () {
  // 	// Product Gallery block
  // 	const $sliders = $(".mproduct__main-gallery");

  // 	if (!$sliders.length) {
  // 		return;
  // 	}

  // 	const $slidersThumb = $(".mproduct__thumb-gallery");

  // 	toggleSwiperClass($slidersThumb);

  // 	const sliderThumb = new Swiper($slidersThumb[0], {
  // 		createElements: false,
  // 		centeredSlides: false,
  // 		loop: true,
  // 		slidesPerView: 3,
  // 		spaceBetween: 15,
  // 		slideToClickedSlide: true,
  // 		direction: "horizontal",
  // 		navigation: {
  // 			nextEl: ".swiper-button-next",
  // 			prevEl: ".swiper-button-prev",
  // 		},
  // 		breakpoints: {
  // 			440: {
  // 				direction: "horizontal",
  // 				slidesPerView: 5,
  // 				spaceBetween: 15,
  // 			},
  // 			540: {
  // 				direction: "vertical",
  // 				slidesPerView: 5,
  // 				spaceBetween: 15,
  // 			},
  // 			1320: {
  // 				spaceBetween: 22,
  // 				direction: "vertical",
  // 				slidesPerView: 5,
  // 			},
  // 		},
  // 	});

  // 	toggleSwiperClass($sliders);

  // 	new Swiper($sliders[0], {
  // 		createElements: false,
  // 		slidesPerView: 1,
  // 		centeredSlides: false,
  // 		loop: false,
  // 		spaceBetween: 0,
  // 		thumbs: { swiper: sliderThumb },
  // 	});
  // })();

  var productSwitcher = function () {
    var $switcher = $(".product-switcher");
    if (!$switcher.length) {
      return;
    }
    $switcher.change(function () {
      var val = $(this).val();
      window.location = val;
    });
  }();
  var blogHero = function () {
    var $sliders = $(".blog-hero__loop");
    if (!$sliders.length) {
      return;
    }
    toggleSwiperClass($sliders);
    var slider = new Swiper($sliders[0], {
      slidesPerView: 1,
      centeredSlides: false,
      loop: true,
      spaceBetween: 0,
      // hashNavigation: {
      //     watchState: true,
      // },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
    swipersAll.forEach(function (swiper) {
      swiper.on("slideChange", function () {
        swiper.pagination.render();
        swiper.pagination.update();
      });
    });
  }();
  (function () {
    // Subscribe page
    // Subscribe products
    var $productRows = $(".product-row");
    if (!$productRows.length) {
      return;
    }
    $productRows.each(function () {
      var $this = $(this);
      $this.find(".frequency-options input[type=radio]").change(function () {
        var $sellingPlan = $this.find(".frequency-form input[name=selling_plan]");
        $sellingPlan.val(this.value);
      });
    });

    // Equalize Height products
    equalizeHeight(".product-rows .equalize-products", {
      reset: true,
      children: ".product-row__content"
    });
  })();
  var adjustItems = function () {
    var $header = $(".gheader__main");
    var $window = $(window);
    $window.resize(function () {
      var headHeight = $header.outerHeight();
      var windowHeight = $window.outerHeight();

      // var heroOffset = headHeight;
      // var headHeight= headHeight
      var heroPadding = headHeight;
      if ($window.width() < 960) {
        heroPadding += 24;
      } else {
        heroPadding += 48;
      }

      // $('.hero').css('padding-top', heroPadding);
      // $('main').css('margin-top', ((headHeight * -1) - 1));
    });
    $window.trigger("resize");

    // $('.gheader').css({ position: 'sticky' });
  }();
  var ImageCarousel = function () {
    var $section = $(".image-carousel");
    if (!$section.length) {
      return;
    }
    var swiper = new Swiper(".image-carousel .swiper", {
      slidesPerView: "auto",
      centeredSlides: true,
      lazy: true,
      loop: true,
      navigation: {
        nextEl: ".image-carousel .swiper-button-next",
        prevEl: ".image-carousel .swiper-button-prev"
      }
    });
  }();
  (function () {
    // set site location cookie
    function setCookie(c_name, value, expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie = c_name + "=" + value + ";path=/" + (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) + ";SameSite=Lax";
    }
    function getCookie(name) {
      var dc = document.cookie;
      var prefix = name + "=";
      var begin = dc.indexOf("; " + prefix);
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
      } else {
        begin += 2;
      }
      var end = document.cookie.indexOf(";", begin);
      if (end == -1) {
        end = dc.length;
      }
      return unescape(dc.substring(begin + prefix.length, end));
    }
    var loc = getCookie("user_location");
    if (!loc) {
      fetch("https://geo.ipify.org/api/v2/country,city?apiKey=at_TwqCswDOi02MNS0VVGB1wdih4w4yj").then(function (response) {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      }).then(function (payload) {
        if (payload.location.country) {
          setCookie("user_location", payload.location.country, 90);
          manageMsgLocation(payload.location.country);
        }
        if (payload.location.region) {
          setCookie("user_region", payload.location.region, 90);
        } else {
          setCookie("user_region", payload.city, 90);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  })();
  AOS.refresh();
  $(window).trigger("scroll");
});